import * as Icons from "lucide-react";
import { SectionHeader } from "@/components/ui/SectionHeader";

export const QuickBenefits = ({ benefits = [] }) => (
  <section id="benefits" className="gm-section">
    <div className="gm-container">
      <SectionHeader
        eyebrow="What it does"
        title="Why traders pick Goldmap EA"
        subtitle="Execution, risk limits and a routine you can follow. Semua yang penting sudah ada inside."
        testId="benefits-header"
      />

      <div
        className="mt-10 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-4"
        data-testid="benefits-grid"
      >
        {benefits.map((b, i) => {
          const Icon = Icons[b.icon] || Icons.Circle;
          return (
            <article key={b.slug || b.title} data-testid={`benefit-card-${b.slug || i}`}>
              <Icon
                className="h-5 w-5"
                style={{ color: "var(--gm-red)" }}
                aria-hidden="true"
              />
              <h3 className="mt-3 text-[0.95rem] font-bold text-white">{b.title}</h3>
              <p
                className="mt-1.5 text-sm leading-relaxed"
                style={{ color: "var(--gm-muted)" }}
              >
                {b.body}
              </p>
            </article>
          );
        })}
      </div>
    </div>
  </section>
);
